import equipment from "./equipment"

export default {

    namespaced: true,

    modules: {
        equipment,
    },

}
